<template>
  <v-layout class="restaurant-items-container">
    <v-container fluid>
      <v-card>
        <v-card-title :class="{ 'mb-2': settings && settings.multipleMenus }">
          <span>{{ $t('items') }}</span>
          <v-select
            v-if="settings && settings.multipleMenus"
            class="all-white white--text v-select--no-black font-weight-light v-select--inline col-auto ml-2"
            :items="menuOptions"
            rounded
            single-line
            v-model="selectedMenuId"
            label="Menú"
            hide-details
            background-color="#e48b46"
            dark
            color="#fff"
            item-value="id"
            solo
            flat
            dense
            item-text="name"
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              hasEditPermissions &&
              settings &&
              !settings.multipleMenus &&
              itemsLoaded
            "
            text
            class="mr-2"
            :to="`/${restaurant.stringId}/menu/import`"
            ><v-icon left>mdi-camera-outline</v-icon
            >{{
              itemCount > 0
                ? $t('items.updateFromPhotos')
                : $t('items.importFromPhotos')
            }}</v-btn
          >
          <v-btn
            color="green"
            class="white--text"
            @click="createNewItem"
            v-if="hasEditPermissions"
            :disabled="!category"
            >{{ $t('item.new') }}</v-btn
          >
        </v-card-title>
        <v-card-subtitle>
          {{ $t('items.subtitle') }}
        </v-card-subtitle>
        <v-card-text>
          <v-toolbar class="rounded-toolbar mb-6" color="#e06f18" dense>
            <v-col>
              <span class="white--text mr-2">{{ $t('category') }}</span>
              <v-select
                class="categories-select v-select--inline theme--dark"
                :items="categories"
                v-model="category"
                item-text="name"
                return-object
                solo-inverted
                flat
                hide-details
                dense
                @change="categoryChanged"
              ></v-select>
            </v-col>
          </v-toolbar>
          <template
            v-if="!settings || !categories || (categories.length && !items)"
          >
            <v-skeleton-loader type="sentences" />
          </template>
          <template v-else-if="!categories.length">
            {{ $t('items.noCategories') }}
          </template>
          <template v-else-if="!items.length">
            {{ $t('items.empty') }}
          </template>
          <template v-else>
            <draggable
              v-model="items"
              @change="change"
              :disabled="!hasEditPermissions"
              :delay="500"
              :delay-on-touch-only="true"
            >
              <transition-group>
                <v-list-item
                  class="item-item"
                  v-for="item in items"
                  :key="item.id"
                >
                  <v-list-item-avatar v-if="hasEditPermissions">
                    <v-icon class="handle">drag_handle</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="name">
                    <div class="children-inline text-no-wrap">
                      <div
                        v-if="item.picture"
                        class="picture mr-2"
                        :style="{
                          backgroundImage: `url('${uploadsPath}/${$thumb(
                            item.picture
                          )}')`,
                        }"
                      ></div>
                      <div>
                        <div class="children-inline">
                          <span>{{ item.name }}</span>
                          <img
                            v-for="allergen of allergens"
                            v-if="
                              (allergen.id & item.allergens) === allergen.id
                            "
                            class="allergen-img mr-1"
                            :src="`${uploadsPath}/static/alergenos/${allergen.picture}.png`"
                          />
                        </div>
                        <div
                          class="meta grey--text d-flex flex-row align-center"
                        >
                          <span
                            class="price font-weight-medium mr-2"
                            :class="{
                              'price--with-discount':
                                item.discountedPrice !== null,
                            }"
                            >{{ currency.symbol }}{{ item.price }}</span
                          >
                          <span
                            v-if="item.discountedPrice !== null"
                            class="discounted-price font-weight-medium mr-2"
                            >{{ currency.symbol
                            }}{{ item.discountedPrice }}</span
                          >
                          <span class="description mr-1">{{
                            item.description
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </v-list-item-content>
                  <v-list-item-action class="flex-row align-center">
                    <div
                      class="disabled-in-branch d-flex align-center"
                      v-if="
                        branches.length > 1 &&
                        item.visible &&
                        !availableInBranch(item)
                      "
                    >
                      <span>En sucursal actual</span>
                      <v-switch
                        color="green"
                        dense
                        :disabled="!hasDisablePermissions"
                        :input-value="false"
                        @change="setVisibility(item, true, false)"
                      ></v-switch>
                    </div>
                    <v-btn
                      v-if="item.hourRanges === null || effectiveTier === 0"
                      icon
                      @click="editHours(item)"
                      v-tooltip="
                        effectiveTier === 0
                          ? 'La restricción horaria solo está disponibles en los planes Plus y Pro'
                          : undefined
                      "
                    >
                      <v-icon>mdi-clock-outline</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      @click="editHours(item)"
                      v-tooltip="
                        effectiveTier === 0
                          ? 'La restricción horaria solo está disponibles en los planes Plus y Pro'
                          : undefined
                      "
                      fab
                      x-small
                      dark
                      :color="
                        timeInsideHours(
                          item.hourRanges,
                          branch.location ? branch.location.tz : null
                        )
                          ? '#4caf50'
                          : '#e44949'
                      "
                      depressed
                    >
                      <v-icon>mdi-clock-outline</v-icon>
                    </v-btn>
                    <v-btn icon @click="edit(item)" v-if="hasEditPermissions"
                      ><v-icon>edit</v-icon></v-btn
                    >
                    <visibility-switch
                      :visible="
                        branches.length === 1
                          ? item.visible && availableInBranch(item)
                          : item.visible
                      "
                      :only-all="branches.length === 1"
                      :branch="branch"
                      :color="
                        branches.length > 1 &&
                        item.visible &&
                        !availableInBranch(item)
                          ? 'orange'
                          : 'green'
                      "
                      :disabled="
                        !hasDisablePermissions ||
                        (allBranches.length !== branches.length &&
                          !item.visible)
                      "
                      @changeAll="setVisibility(item, $event, true)"
                      @changeBranch="setVisibility(item, $event, false)"
                    />
                  </v-list-item-action>
                </v-list-item>
              </transition-group>
            </draggable>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
    <v-toolbar v-if="orderChanged" class="order-toolbar" dense floating>
      <span class="pr-4">{{ $t('orderChanged') }}</span>
      <v-btn @click="saveOrder" color="info" :loading="savingOrder">
        {{ $t('save') }}
      </v-btn>
    </v-toolbar>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import draggable from 'vuedraggable';
  import { IItem } from '../../interfaces/IItem';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import NewItemModal from '../modals/NewItemModal.vue';
  import HourItemsModal from '../modals/HourRangesModal.vue';
  import ItemsService from '../../api/services/items.service';
  import RestaurantsService, {
    IRestaurantSettings,
  } from '../../api/services/restaurants.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import { ICategory } from '../../interfaces/ICategory';
  import { allergens } from '../../enums/Allergens';
  import { Globals } from '../../modules/Globals';
  import { ICurrency } from '../../interfaces/ICurrency';
  import { PermissionType } from '../../enums/PermissionType';
  import { IMenu } from '../../interfaces/IMenu';
  import MenusService from '../../api/services/menus.service';
  import { IBranch } from '../../interfaces/IBranch';
  import { ISimpleHourRange } from '../../interfaces/ISimpleHourRange';
  import { timeInsideHours } from '../../utils';
  import VisibilitySwitch from '../partials/VisibilitySwitch.vue';
  import { getDefaultVatRate } from '@/const/countryVatRates';
  import { getEffectiveTier } from '@/utils/billing-entitlements.utils';
  import { EventBus } from '@/modules/EventBus';
  import { MENU_UPDATE_UNDONE_EVENT } from '@/domain/menu-import/update-undo';

  @Component({
    components: { VisibilitySwitch, draggable },
  })
  export default class RestaurantItems extends Vue {
    itemsService = new ItemsService();
    restaurantsService = new RestaurantsService();
    menusService = new MenusService();
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    @Prop() allBranches: IBranch[];
    @Prop() branches: IBranch[];
    @Prop() currency: ICurrency;
    categories: ICategory[] = [];
    category: ICategory = null;
    items: IItem[] = null;
    menus: IMenu[] = null;
    settings: IRestaurantSettings = null;
    allergens = allergens;
    apiPath = Globals.apiPath;
    uploadsPath = Globals.uploadsPath;
    orderChanged = false;
    savingOrder = false;
    itemCount = 0;
    /** The first load finished: «Cargar» or «Actualizar desde fotos» is known. */
    itemsLoaded = false;

    selectedMenuId = null;
    justLoad = true;
    timeInsideHours = timeInsideHours;

    get effectiveTier(): number {
      return getEffectiveTier(this.restaurant);
    }

    created() {
      EventBus.$on(MENU_UPDATE_UNDONE_EVENT, this.onMenuUpdateUndone);
    }

    mounted() {
      this.init();
    }

    beforeDestroy() {
      EventBus.$off(MENU_UPDATE_UNDONE_EVENT, this.onMenuUpdateUndone);
    }

    /** An update from photos was undone: the dishes shown changed. */
    async onMenuUpdateUndone() {
      await this.loadCategories();
      await this.loadItems();
    }

    async init() {
      await this.loadMenus();
      await this.loadCategories();
      await Promise.all([this.loadItems(), this.loadSettings()]);
      this.justLoad = false;
    }

    async loadSettings() {
      this.settings = await this.restaurantsService.getSettings(
        this.restaurant.id
      );
    }

    change(e) {
      if (!e.moved) return;

      const data: { element: IItem; oldIndex: number; newIndex: number } =
        e.moved;

      this.items.forEach((value, index) => {
        value.index = index;
      });

      this.orderChanged = true;
    }

    async loadMenus() {
      this.menus = await this.menusService.getAll(this.restaurant.id);

      const mId = this.$route.query.mId as string;
      if (mId && mId !== 'def') {
        if (this.menus.some((value) => value.id === +mId))
          this.selectedMenuId = +mId;
        else {
          const query = Object.assign({}, this.$route.query);
          delete query.mId;
          this.$router.replace({ query });
        }
      }
    }

    get menuOptions() {
      return [{ id: null, name: 'Menú por defecto' }, ...this.menus];
    }

    @Watch('selectedMenuId')
    async onSelectedMenuChanged(menuId: number) {
      if (this.justLoad) return;

      this.items = null;
      this.categories = null;

      const query = Object.assign({}, this.$route.query);
      if (menuId !== null) query.mId = menuId + '';
      else delete query.mId;
      delete query.cId;
      this.$router.replace({ query });

      await this.loadCategories();
      await this.loadItems();
    }

    async saveOrder() {
      this.savingOrder = true;

      try {
        const ids = this.items.map((value) => value.id);
        const indexes = this.items.map((value) => value.index);

        await this.itemsService.saveOrder(this.restaurant.id, ids, indexes);
      } catch (e) {
      } finally {
        this.orderChanged = false;
        this.savingOrder = false;
      }
    }

    availableInBranch(item: IItem) {
      return (
        !item.hiddenBranchesIds ||
        item.hiddenBranchesIds.indexOf(this.branch.id + '') === -1
      );
    }

    async setVisibility(item: IItem, val: boolean, allBranches: boolean) {
      allBranches =
        allBranches && this.branches.length === this.allBranches.length;
      if (allBranches) {
        await this.changeVisible(val, item);
      } else {
        try {
          const storedItem = await this.itemsService.getById(item.id);
          const branchIds = (storedItem.hiddenBranchesIds =
            storedItem.hiddenBranchesIds ?? []);
          const index = branchIds.indexOf(this.branch.id + '');
          if (!val) {
            if (index === -1) branchIds.push(this.branch.id + '');
          } else {
            if (index > -1) branchIds.splice(index, 1);
          }
          await this.itemsService.update(storedItem);

          item.hiddenBranchesIds = storedItem.hiddenBranchesIds;
        } catch (e) {
          console.error(e);
          vueData.serverError(e);
        }
      }
    }

    async changeVisible(newValue: boolean, item: IItem) {
      try {
        item.visible = newValue;

        if (newValue) await this.itemsService.activate(item);
        else await this.itemsService.deactivate(item);
      } catch (e) {
        vueData.addAlert(
          this.$tc('errors.statusChangeFailed'),
          AlertType.Error
        );
        item.visible = !newValue;
      }
    }

    get hasEditPermissions() {
      return vueData.hasPermission(PermissionType.CatalogManage);
    }

    get hasDisablePermissions() {
      return vueData.hasPermission(PermissionType.CatalogDisable);
    }

    createNewItem() {
      this.$modal.show(
        NewItemModal,
        {
          restaurant: this.restaurant,
          branch: this.branch,
          branches: this.branches,
          currency: this.currency,
          menuId: this.selectedMenuId,
          item: {
            menuId: this.selectedMenuId,
            restaurantId: this.restaurant.id,
            categoryId: this.category.id,
            name: '',
            price: 0,
            picture: null,
            allergens: 0,
            options: [],
            discount: null,
            discountMode: null,
            discountedPrice: null,
            description: '',
            recipe: null,
            stringId: '',
            index: this.items.length,
            hiddenBranchesIds: null,
            vat: getDefaultVatRate(this.restaurant.country),
          },
          category: this.category,
        },
        {
          name: 'edit-item',
          classes: 'dialog--height-limit',
          adaptive: true,
          height: 'auto',
          width: 750,
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          clickToClose: false,
        },
        {
          saved: async () => {
            await this.loadItems();
            if (this.itemCount === 5) {
              vueData.conversion(
                '1036472587',
                'E_r3CNWk8tcBEIuine4D',
                'Añadir 5 items al menú'
              );
            }
          },
        }
      );
    }

    edit(item: IItem) {
      this.$modal.show(
        NewItemModal,
        {
          restaurant: this.restaurant,
          branch: this.branch,
          branches: this.branches,
          menuId: this.selectedMenuId,
          currency: this.currency,
          item: item,
        },
        {
          name: 'edit-item',
          classes: 'dialog--height-limit',
          adaptive: true,
          height: 'auto',
          width: 750,
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          clickToClose: false,
        },
        {
          saved: () => {
            this.loadItems();
          },
          deleted: () => {
            this.items.splice(this.items.indexOf(item), 1);
            this.$modal.hide('edit-item');
          },
        }
      );
    }

    editHours(item: IItem) {
      if (this.effectiveTier === 0) {
        vueData.addAlert(
          'Esta funcionalidad está disponible en planes Plus y Pro',
          AlertType.Info
        );
        return;
      }

      this.$modal.show(
        HourItemsModal,
        {
          item,
          type: 'item',
        },
        {
          name: 'add-item',
          adaptive: true,
          classes: 'dialog--height-limit',
          height: 'auto',
          width: 600,
          scrollable: true,
          clickToClose: false,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: (hours: ISimpleHourRange[]) => {
            item.hourRanges = hours;
          },
        }
      );
    }

    async loadItems() {
      this.savingOrder = this.orderChanged = false;
      if (this.category) {
        const items = await ItemsService.getAll(
          this.restaurant.id,
          this.category.id,
          this.selectedMenuId
        );
        this.items = items;
        this.itemCount = await this.itemsService.getCount(this.restaurant.id);
      } else {
        this.items = null;
      }
      this.itemsLoaded = true;
    }

    categoryChanged() {
      this.items = [];
      const query = Object.assign({}, this.$route.query);
      query.cId = this.category.id + '';
      this.$router.replace({ query });
      this.loadItems();
    }

    async loadCategories() {
      const categories = await RestaurantsService.getCategories(
        this.restaurant.id,
        this.selectedMenuId
      );
      this.categories = categories;

      if (this.categories.length) {
        const catId = this.$route.query.cId;
        if (!catId) this.category = this.categories[0];
        else
          this.category =
            this.categories.find(
              (value) => value.id === parseInt(catId as string)
            ) || this.categories[0];
      }
    }
  }
</script>

<style lang="scss" scoped>
  .disabled-in-branch {
    background-color: #ffe5e5;
    border-radius: 20px;
    padding: 4px 8px 4px 12px;

    span {
      padding-right: 8px;
      text-transform: lowercase;
      font-size: 0.9em;
      color: #8a4949;
    }
  }
</style>
